// extracted by mini-css-extract-plugin
module.exports = {"icon":"ButtonMore_icon__zRsW0","is-less":"ButtonMore_is-less__wpCsk"};